export default __webpack_public_path__ + "static/media/active-level-0.17284e37.svg";